module.exports = __webpack_public_path__ + "img/pauli-x-root-20.4c557f16.svg";